import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export interface Attachment extends Record, Dateable {
	accountId: number;
	userId: number;
	title: string;
	description: string;
	type: AttachmentType;
	status: AttachmentStatus;
	url: string;
	previewUrl: string;
	size: number;

	/** A voice note's length in seconds. */
	duration?: number;
	/** A voice note's waveform, one bar height each, `0..100`. */
	peaks?: number[];
	/**
	 *	An image or video's pixel size, upright, so its box can be laid out
	 *	before it loads. Missing when the API doesn't know it, as for any sent
	 *	before it stored one.
	 */
	width?: number;
	height?: number;

	// used to track upload state, never stored in the API
	bytesUploaded?: number;

	/**
	 * uploadUrl is where the client should send files when uploading an attachment.
	 */
	uploadUrl?: string;

	// Used to greedily render attachment items before we get response from API.
	tmpId?: string;
}

export enum AttachmentType {
	Image = 'image',
	Video = 'video',
	Audio = 'audio',
	File = 'file',
	/** Audio recorded in a chat, drawn as a voice message. Only chat creates one. */
	Voice = 'voice',
}

/** The types a field or form can ask for: a voice note is only ever recorded in a chat. */
export const PickableAttachmentTypes: AttachmentType[] = Object.values(
	AttachmentType
).filter((type) => type !== AttachmentType.Voice);

export enum AttachmentVisibility {
	Visible = 'default',
	Hidden = 'hidden',
}

export enum AttachmentStatus {
	Uploading = 'uploading',
	Processing = 'processing',
	Normal = 'normal',
	WillDelete = 'will_delete',
	Failed = 'failed',
}
